import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"no-gutters":"","id":"avatar-wrapper"}},[_c(VCol,{attrs:{"align":"center","justify":"center","id":"divVHSS"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }